var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.tirList.length)?_c('div',_vm._l((_vm.tirList),function(tir,index){return _c('div',{key:tir.id,staticClass:"taskWrapper"},[_c(_setup.TirDetail,{attrs:{"tir":tir,"index":index,"showCheckBoxOptions":_vm.showCheckBoxOptions}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }